<template>
  <div class="filter_selector">
    <ButtonSwipe :options="options"  @change="selectFilter" v-if="!selectedFilter"
      groupClass="d-lg-block" itemClass="mb-lg-1" />
    <b-button-group v-if="selectedFilter" class="d-flex justify-content-end">
      <b-button class="text-left no-pointer" variant="primary">
        {{selectedFilter.description}}
      </b-button>
      <b-button class="flex-grow-0" variant="primary" @click="deleteFilter(selectedFilter)">
        <img src="@/assets/images/trashcan.svg">Apagar</b-button>
      <b-button class="flex-grow-0" variant="primary" @click="deselectFilter">X</b-button>
    </b-button-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ButtonSwipe from './ButtonSwipe';

export default {
  name: 'FilterSelector',
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  components: {
    ButtonSwipe,
  },
  computed: {
    ...mapGetters(['selectedFilter']),
  },
  methods: {
    ...mapActions(['deselectFilter', 'selectFilter', 'deleteFilter']),
  },
};
</script>
